import { FC, useMemo } from 'react';

import { useLocale } from '../../../../hooks/use-locale';

// Источник: https://github.com/x88/i18nGeoNamesDB
import areas from './areas.json';
import { SelectForm, SelectFormProps } from './SelectForm';

type AreaSelectFormProps = Omit<SelectFormProps<string>, 'options'>;

export const AreaSelectForm: FC<AreaSelectFormProps> = (props) => {
  const locale = useLocale();

  const areasOptions = useMemo(() => {
    return areas
      .map((val) => ({ value: val[locale] }))
      .sort((v1, v2) => {
        if (v1.value < v2.value) return -1;
        if (v1.value == v2.value) return 0;

        return 1;
      });
  }, [locale]);

  return <SelectForm {...props} options={areasOptions} />;
};
